import gql from 'graphql-tag'

export const loginFieldsFragment = gql`
  fragment loginFields on LoginForm {
    fields{
      name
      type
      required
      value
      title
    }
  }
`

export const getMe = gql`
  query getMe {
    me{
      id
      profile {
        fields{
          name
          value
        }
      }
    }
  }
`
export const getLoginForm = gql`
  query getLoginForm {
    getLoginForm(method: email ){
      flow
      method
        ...loginFields
    }
  }

  ${loginFieldsFragment}
`

export const LoginDocument = gql`
  mutation Login( $form: ILoginForm!){
    Login( form: $form) {
      jwt_token
      jwt_refresh_token
    }
  }
`
export const RefreshLogin = gql`
  mutation RefreshLogin{
    RefreshLogin{
      jwt_token
      jwt_refresh_token
    }
  }
`
